import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { ProjetoDocumentoService } from "../services/projeto-documentos.service";

@Injectable({
  providedIn: 'root'
})
export class ProjetoDocumentoResolver implements Resolve<boolean> {

  constructor(private service: ProjetoDocumentoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}


@Injectable({
  providedIn: 'root'
})
export class ProjetoDocumentoFiltersResolver implements Resolve<boolean> {

  constructor(private service: ProjetoDocumentoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getListFilters();
  }
}